/**
 * YT Parts Filter – Client-side filtering for the section's own product grid.
 * Reads metafield values from data-* attributes on grid items and shows/hides
 * them based on dropdown selections. Hides pagination when filters are active.
 */
class YtPartsFilter extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('.yt-pf__grid');
    if (!this.grid) return;

    this.emptyEl = this.querySelector('.yt-pf__empty');
    this.paginationEl = this.querySelector('.yt-pf__pagination');
    this.resetBtn = this.querySelector('.yt-pf__reset');

    this.addEventListener('change', (e) => {
      if (e.target.matches('.yt-pf__select')) {
        this.applyFilters();
      }
    });

    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', () => {
        this.querySelectorAll('.yt-pf__select').forEach(function (s) {
          s.value = '';
        });
        this.applyFilters();
      });
    }
  }

  applyFilters() {
    var filters = {};
    this.querySelectorAll('.yt-pf__select').forEach(function (select) {
      var key = select.dataset.filter;
      var val = select.value;
      if (key && val) {
        filters[key] = val.toLowerCase();
      }
    });

    var hasActiveFilter = Object.keys(filters).length > 0;
    var attrMap = {
      bike_model: 'bikeModel',
      model_evolution: 'modelEvolution',
      model_year: 'modelYear',
      parts_type: 'partsType',
    };
    var cards = this.grid.querySelectorAll('.yt-pf__product');
    var visibleCount = 0;
    var self = this;

    cards.forEach(function (card) {
      if (!hasActiveFilter) {
        card.hidden = false;
        visibleCount++;
        return;
      }

      var match = true;
      var filterKeys = Object.keys(filters);
      for (var i = 0; i < filterKeys.length; i++) {
        var key = filterKeys[i];
        var filterVal = filters[key];
        var attrKey = attrMap[key];
        var productVal = (card.dataset[attrKey] || '').toLowerCase();
        if (!self.matchesFilter(productVal, filterVal)) {
          match = false;
          break;
        }
      }

      card.hidden = !match;
      if (match) visibleCount++;
    });

    if (this.resetBtn) {
      this.resetBtn.hidden = !hasActiveFilter;
    }

    /* Show empty state when filters active and no matches */
    if (this.emptyEl) {
      this.emptyEl.hidden = !hasActiveFilter || visibleCount > 0;
    }

    /* Hide pagination when filters are active (client-side only filters current page) */
    if (this.paginationEl) {
      this.paginationEl.hidden = hasActiveFilter;
    }
  }

  matchesFilter(productVal, filterVal) {
    if (!productVal) return false;
    /* Support list metafields (pipe-separated) */
    var values = productVal.split('|').map(function (v) {
      return v.trim();
    });
    return values.indexOf(filterVal) !== -1;
  }
}

customElements.define('yt-parts-filter', YtPartsFilter);
